import { getCustomMessageFormatted } from '@/helpers'

const renderCustomMessage = message => {
  const formattedMessage = getCustomMessageFormatted(message)

  return <span dangerouslySetInnerHTML={{ __html: formattedMessage }} /> // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
}

export const getCustomReason = (customTextReasons, reason, info) => {
  const message = customTextReasons?.find(customReason => customReason.key === `error.${reason}`)?.[info]

  if (message) return renderCustomMessage(message)
}

export const getOverrideMessage = ({ reason, disabledByRuleMessage, lang }) => {
  if (reason === 'disabled_by_rule' && disabledByRuleMessage?.[lang]) {
    return renderCustomMessage(disabledByRuleMessage?.[lang])
  }

  return null
}
